const spatialModelRequests = {
  createSpatialModelRequest: (data) => ({
    url: `api/pages/360view`,
    method: 'post',
    data,
  }),
}

export default spatialModelRequests
